import { Card } from "@mantine/core";
import { ILabelAndIsActive } from "@mctypes/frontend.types";
import { ColDef } from "ag-grid-community";
import React from "react";
import { useHistory } from "react-router-dom";
import MainFilterBar from "../../../../components/MainFilterBar/MainFilterBar";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import {
  clearAllMeetingFilterThunk,
  toggleAllMultiMeetingsFilterInRedux,
  toggleMeetingBoolFilterThunk,
  toggleOptionInMeetingFiltersInRedux,
} from "../meetingSlice";
import { MeetingListItem } from "../meetingApiTypes";

const MeetingDbFilterBar: React.FC<{ columns: ColDef<MeetingListItem>[] }> = ({ columns }) => {
  const allFilters = useAppSelector((state) => state.meetingReducer.allFilters);

  const dispatch = useAppDispatch();

  const getFormattedMultifilterItems = () => {
    return (allFilters ?? []).reduce((acc, allFilterItem) => {
      if (allFilterItem.options != null) {
        const col = columns?.find((_col) => _col.field.startsWith(allFilterItem.dataField));
        if (col != null) {
          const filterItem = {
            title: col.headerName,
            options: allFilterItem.options,
          };
          acc.push(filterItem);
        }
      }
      return acc;
    }, []);
  };

  const getFormattedBoolFilters = (): ILabelAndIsActive[] => {
    return (allFilters ?? []).reduce((acc, allFilterItem) => {
      if (allFilterItem.bool != null) {
        const col = columns?.find((_col) => _col.field.startsWith(allFilterItem.dataField));
        if (col != null) {
          const filterItem: ILabelAndIsActive = {
            label: col.headerName,
            isActive: allFilterItem.bool,
          };
          acc.push(filterItem);
        }
      }
      return acc;
    }, []);
  };

  const multipleFilterItems = getFormattedMultifilterItems();
  const boolFilterItems = getFormattedBoolFilters();

  const getDataField = (colTitle: string): string => {
    console.log("colTitle", colTitle);
    return columns.find((col) => col.headerName === colTitle)?.field;
  };

  const history = useHistory();

  const reset = () => {
    history.push(`${history.location.pathname}`);
    dispatch(clearAllMeetingFilterThunk());
  };

  return (
    <>
      {multipleFilterItems != null && (
        <Card mx="xxs" p="xs" withBorder radius="sm" bg={"#fafafb"} bd={"1px solid var(--mantine-color-warmgray-2)"}>
          <MainFilterBar
            // onUpdateSearch={(str) => dispatch(setMeetingFreeTextSearchInRedux(str))}
            // searchText={freeTextSearch}
            multipleFilterItems={multipleFilterItems}
            booleanFilterItems={boolFilterItems}
            updateMultiFilterItemOption={(title, value) =>
              dispatch(
                toggleOptionInMeetingFiltersInRedux({
                  dataField: getDataField(title),
                  optionValue: value,
                }),
              )
            }
            updateBooleanFilterItem={(title) =>
              dispatch(toggleMeetingBoolFilterThunk(columns.find((col) => col.headerName === title)?.field))
            }
            clearAllFilters={reset}
            resetMultiFilter={(title) =>
              dispatch(
                toggleAllMultiMeetingsFilterInRedux({
                  dataField: getDataField(title),
                  isActive: false,
                }),
              )
            }
            selectAllMultiFilter={(title) =>
              dispatch(
                toggleAllMultiMeetingsFilterInRedux({
                  dataField: getDataField(title),
                  isActive: true,
                }),
              )
            }
          />
        </Card>
      )}
    </>
  );
};

export default MeetingDbFilterBar;
